import { GET_PERMISSIONS, GET_PERMISSIONS_SUCCESS, SET_PERMISSIONS } from "./actionTypes";


export const getPermissions = (token, history) => {
  return {
      type: GET_PERMISSIONS,
      payload: { token, history }
  }
}


export const getPermissionsSuccess = (permissions) => {
  return {
    type: GET_PERMISSIONS_SUCCESS,
    payload: {permissions}
  };
};

export const setPermissions = (permissions) => {
  return {
    type: SET_PERMISSIONS,
    payload: permissions
  };
};